export default {
  title: 'Microaudiência Projetada vs Diferença Última Onda (%)',
  infoDialog: 'Tendência da contribuição estimada de KPI por microaudiências (diferença projetada vs último período)',
  kpi: 'KPI'
}
